/**
 *
 * @param {TESTE teste} text
 * @returns Teste Teste
 */
export function capitalizeFirstLetters(text) {
  if (!text) return '';
  return text
    .split(' ')
    .map(word =>
      word
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join('-')
    )
    .join(' ');
}

/**
 *
 * Normaliza o texto que vem do campo sexo.
 */
export function normalizaSexo(valor) {
  if (!valor) return ''
  const str = String(valor).trim().toUpperCase()
  // Checa se contém 'F' (mas não 'M')
  if (str === 'F' || str.startsWith('FEM')) return 'F'
  // Se tiver só o caractere F em qualquer posição, considera também feminino
  if (str.length === 1 && str === 'F') return 'F'
  return 'M'
}
/**
 * Remove todos os caracteres especiais
 */
export function limparTexto(texto) {
  // Remove tudo que não for dígito
  return String(texto).replace(/\D/g, '');
}

/**
 * Escapa caracteres especiais para uso seguro em HTML montado por concatenação
 */
export function escapeHtml(texto) {
  if (texto === null || texto === undefined) return ''
  return String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
